var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.1663,
    cy: 19.8333,
    rx: 17.8333,
    ry: 17.8333,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 8.95431 8.95427 0 19.9999 0H20.1161C25.405 0.0153897 30.4712 2.13118 34.2001 5.88191C37.929 9.63264 40.0153 14.7111 39.9998 20C39.9998 31.0457 31.0456 40 19.9999 40C8.95427 40 0 31.0457 0 20ZM18.2566 27.6997L20.3389 20.6779L23.5834 19.7578L24.2614 17.4334L21.0653 18.4019L24.4551 6.87648V6.69246C24.45 6.54345 24.386 6.40256 24.277 6.30082C24.168 6.19909 24.023 6.14486 23.874 6.15009H19.5641C19.2283 6.13974 18.9287 6.35945 18.8377 6.68278L14.8183 20.339L11.6222 21.3075L10.8958 23.5351L14.0919 22.5666L11.2348 32.3002H28.2807C28.6176 32.3141 28.9192 32.093 29.0071 31.7675L29.9757 28.4261V28.2421C29.9706 28.0931 29.9065 27.9522 29.7975 27.8505C29.6885 27.7487 29.5436 27.6945 29.3945 27.6997H18.2566Z",
    fill: "#345D9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLtc);
export default __webpack_public_path__ + "static/media/ltc.0920e6a81a88c8cf984af0fb25de30c0.svg";
export { ForwardRef as ReactComponent };